import React, { Component } from 'react'
import { imageAddress, priceStandardView, translate } from '../../utils/useful'
import Responsive from '../../components/Responsive'

export default class ProductViewBox extends Component {

    onClick = (data) => {
        this.props.onClick(data._id)
    }


    render() {


        return (
            <div className='d-flex h-100'>
                <Responsive width={this.props.width} height={'100%'} media={{ xs: '12', 400: '6', 700: '3', lg: '3', xl: '3' }}>
                    <div className='br-15 flex-column product-view-box bg-white h-100 cursor-pointer d-flex flex-column' style={{ overflow: 'hidden', border: '1px solid #F6F6F6', boxShadow: '0px 0px 20px #10101010' }} onClick={() => this.onClick(this.props.data)}>
                        <div className='flexcc w-100' style={{ position: 'relative' }} >
                            <div className='w-100 p-1'>
                                <img className='w-100' style={{ borderRadius: '10px 10px 0px 0px', objectFit: 'cover', aspectRatio: ' 1 / 1' }} src={imageAddress(this.props.data.media)} alt="" />
                            </div>
                            {this.props?.data?.priceSttings?.discount?.value > 0 && (
                                <div className='discount-box px-2 py-1 br-30' style={{ position: 'absolute', top: 5, right: 5 }}>
                                    <p className='white font-size-12 flexcc'> {this.props?.data?.priceSttings?.discount.value} {this.props?.data?.priceSttings?.discount.type != 'cash' ? '%' : ''}</p>
                                </div>
                            )}
                        </div>
                        <div className=' pb-3 pt-2'>
                            <p className='font-size-16 weight-500 main-c4 px-2'>{this.props.data.name}</p>
                            <p className='font-size-12 weight-400 main-c7 px-2 line-clamp2 mt-1'>{this.props.data?.description}</p>
                            <div className='mt-2 flexc px-2'>
                                <p className='font-size-16 main-c4 text-semibold'>{this.props?.data?.priceSttings?.currency ?? '$'}{priceStandardView(this.props.data.price?.final)} </p>
                                {this.props.data.price?.onSale && (
                                    <p className='font-size-12  px-1 text-semibold' style={{ color: '#777' }}>{translate("Was")}: <span className='text-lined'>{this.props?.data?.price?.currency ?? '$'}{this.props.data.price?.base}</span></p>
                                )}
                            </div>

                        </div>

                        <div className='flex-1'>

                        </div>

                        <div className='d-flex px-2 mb-3' style={{ paddingRight: '10px' }}>
                            <button className='flexc mt-2'>
                                <p className='w-100 font-size-12' style={{ color: '#007aff' }}>{translate("View Product")}</p>
                                <img className='flexcc mt-1 mld-1' width={16} src='/assets/icons/point-right-blue.svg' />
                            </button>
                        </div>
                    </div>
                </Responsive>
            </div>
        )
    }
}
